import { FaInfoCircle } from 'react-icons/fa';
import Table from '@/components/table';
import { SectionContainer } from '@/features/reports/components/section-container';
import type { ReportDataType } from '@/features/reports/context/report-data-context';
import type { Meeting } from '@/graphql/types';
import { DateHelpers, lastNightTableDates } from '@/helpers/date-helpers';
import { LastNightTooltip } from '@/reports/last-night-table';

type LastNightSummaryProps = {
  lastNightData: ReportDataType['lastNightData'];
  loadingReport: boolean;
  meeting?: Meeting;
};

export const LastNightSummary = ({
  lastNightData,
  loadingReport,
  meeting,
}: LastNightSummaryProps) => {
  const tableDates = lastNightTableDates(meeting?.meetingDate || DateHelpers.today());

  return (
    <SectionContainer
      anchorId='last-night'
      title='Last Night Summary'
      toolbar={
        <div>
          <FaInfoCircle className='text-blue-500' data-tip data-for='last-night-summary' />
          <LastNightTooltip tableDates={tableDates} />
        </div>
      }
    >
      {loadingReport ? <span>Loading...</span> : <Table {...lastNightData} />}
    </SectionContainer>
  );
};
